import React, { useContext } from 'react'
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Login from '../Authentication/Login';
import MainHeader from '../Components/Header/MainHeader';
import MainHeaderRedemption from '../Components/Header/MainHeaderRedemption';
import Home from '../Pages/Home';
import QCSHome from '../Pages/QrCodeScanning/QCSHome';
import ProductsListingRedem from '../Pages/Redemption/ProductsListingRedem';
import ProductView from '../Pages/Redemption/ProductView';
import ProductViewClient from '../Pages/Redemption/ProductViewClient';
import Cart from '../Pages/Shopping/Cart';
import CartRedemption from '../Pages/Shopping/CartRedemption';
import Checkout from '../Pages/Shopping/Checkout';
import CheckoutRedemption from '../Pages/Shopping/CheckoutRedemption';
import ClientOrderDetails from '../Pages/Shopping/ClientOrderDetails';
import OrderHistory from '../Pages/Shopping/OrderHistory';
import OrderPlacedSuccess from '../Pages/Shopping/OrderPlacedSuccess';
import ProductsListing from '../Pages/Shopping/ProductsListing';
import PointsHistory from '../Pages/User/PointsHistory';
import Profile from '../Pages/User/Profile';
import UserProfileHolder from '../Pages/User/UserProfileHolder';
import AuthContext from '../Store/AuthContext';

const MainNavigator = () => {
    const authCtx = useContext(AuthContext);
    let isLoggedIn = authCtx?.isLoggedIn;
    // console.log((() => { try { return JSON.parse(authCtx?.loginData ?? '') } catch { return null } })());

    if (!isLoggedIn) {
        return (
            <Routes>
                <Route path="*" element={<Home />}></Route>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/:storeKey" element={<Home />}></Route>
                <Route path="/:storeKey/home" element={<Home />}></Route>
                <Route path="/login/:landingPage" element={<Login />}></Route>
                <Route path="/:storeKey/shop" element={<ProductsListing />}></Route>
                <Route path="/qr-scanning" element={<QCSHome />}></Route>
                <Route path="/redeem" element={<ProductsListingRedem />}></Route>
                <Route path="/redeem/product/:productIdentifier" element={<ProductView />}></Route>
                <Route path="/shop/product/:productIdentifier" element={<ProductViewClient />}></Route>

            </Routes>
        )
    } else {
        return (
            <div>
                <ToastContainer />
                <Routes>
                    <Route path="*" element={<Home />}></Route>
                    <Route path="/:storeKey" element={<Home />}></Route>
                    <Route path="/:storeKey/home" element={<Home />}></Route>
                    <Route path="/:storeKey/shop" element={<ProductsListing />}></Route>
                    <Route path="/shop/cart" element={<Cart />}></Route>

                    <Route path="/:storeKey/checkout" element={<Checkout />}></Route>
                    <Route path="/order-placed/success/:orderIdentifier" element={<OrderPlacedSuccess />}></Route>
                    <Route path="/qr-scanning" element={<QCSHome />}></Route>
                    <Route path="/redeem" element={<ProductsListingRedem />}></Route>
                    <Route path="/redeem/cart" element={<CartRedemption />}></Route>
                    <Route path="/redeem/checkout" element={<CheckoutRedemption />}></Route>
                    
                    <Route path="/redeem/product/:productIdentifier" element={<ProductView />}></Route>
                    <Route path="/shop/product/:productIdentifier" element={<ProductViewClient />}></Route>

                    <Route path="/profile" element={<Profile />}></Route>
                    <Route path="/:ebType/:identifier" element={<UserProfileHolder />}></Route>
                    <Route path="/:ebType/:identifier/:orderIdentifier" element={<UserProfileHolder />}></Route>
                </Routes>
            </div>
        )
    }
}

export default MainNavigator